import React from 'react';
import { CheckCircle } from 'lucide-react';
interface PurchaseNotificationProps {
  name: string;
  city: string;
  product: string;
  isVisible: boolean;
  isHeader?: boolean;
}
export function PurchaseNotification({
  name,
  city,
  product,
  isVisible,
  isHeader = false
}: PurchaseNotificationProps) {
  if (isHeader) {
    return <div className={`flex items-center gap-2 transition-all duration-500 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4 pointer-events-none'}`} data-id="element-10" data-mp="19ahgxilpr13h">
        <div className="bg-orange-500 p-1 rounded-full flex-shrink-0" data-id="element-11" data-mp="21xajm6inyag4">
          <CheckCircle className="w-3 h-3 text-white" data-id="element-12" data-mp="1wy7cmgj4hu5i" />
        </div>
        <div className="min-w-0" data-id="element-13" data-mp="1x0k4bleonivr">
          <p className="text-[10px] md:text-xs font-bold text-white" data-id="element-14" data-mp="1sx5l6lvg6me3">
            <span className="text-orange-400" data-id="element-15" data-mp="1syymrmr7egf8">{name}</span> de {city}
          </p>
          <p className="text-[9px] md:text-[10px] text-blue-200 font-medium" data-id="element-16" data-mp="lkn3ozxhfaip">
            acaba de adquirir: <span className="text-white" data-id="element-17" data-mp="hgfbutvq9eg9">{product}</span>
          </p>
        </div>
      </div>;
  }
  return <div className={`fixed left-4 z-30 transform transition-all duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'} 
      bottom-4`} data-id="element-18" data-mp="1sgpfj6hmu7j0">
      <div className="bg-[#0a1120] rounded-xl p-4 flex items-center gap-3 border-2 border-orange-500 shadow-xl max-w-sm" data-id="element-19" data-mp="1jeydcbmawitw">
        <div className="bg-orange-500/20 p-2 rounded-full flex-shrink-0" data-id="element-20" data-mp="1ninvojcdu46h">
          <CheckCircle className="w-6 h-6 text-orange-500" data-id="element-21" data-mp="19o3qb518df7e" />
        </div>
        <div data-id="element-22" data-mp="1egwtvpkyqhhw">
          <p className="text-sm font-bold text-white" data-id="element-23" data-mp="1ehpr9zy17und">
            <span className="text-orange-400" data-id="element-24" data-mp="zrqwm75or1cn">{name}</span> de{' '}
            <span className="text-orange-400" data-id="element-25" data-mp="zpe4x2a4lcme">{city}</span>
          </p>
          <p className="text-xs text-gray-300 font-medium mt-0.5" data-id="element-26" data-mp="14qv3gr550mzt">
            acaba de adquirir: <span className="text-white" data-id="element-27" data-mp="qrvh5q53kk6t">{product}</span>
          </p>
          <p className="text-[10px] text-gray-500 mt-1" data-id="element-28" data-mp="vq5cq1uqhmsy">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}